module.exports = __webpack_public_path__ + "img/tks.8e7da968.png";